// eventHandlers.js

// Function to emit custom events

/**
 * Emits a custom event when the status of a checkbox changes.
 * @param {string} id - The ID of the checkbox.
 * @param {boolean} isEnabled - Whether the checkbox is checked or not.
 * @category ToolbarScripts
 */
function emitStatusChange(id, isEnabled) {
  const eventName = `${id}`; // Creates a custom event name based on the checkbox ID
  const eventDetail = { enabled: isEnabled }; // Details whether the checkbox is enabled or not
  const event = new CustomEvent(eventName, { detail: eventDetail });
  document.dispatchEvent(event);
  console.log(`Event ${eventName} emitted with status: ${isEnabled}`);
};

// General function to handle checkbox change events

/**
 * Handles the change event for a checkbox.
 * @param {Event} event - The change event object.
 */
function handleCheckboxChange(event) {
  const checkbox = event.target;
  const isChecked = checkbox.checked;
  emitStatusChange(checkbox.id, isChecked);
};

// Function to setup listeners for a list of checkbox IDs

/**
 * Sets up event listeners for a list of checkboxes.
 * @param {string[]} checkboxIds - An array of checkbox element IDs.
 */
function setupCheckboxListeners(checkboxIds) {
  checkboxIds.forEach((id) => {
    const checkbox = document.getElementById(id);
    if (checkbox) {
      checkbox.addEventListener("change", handleCheckboxChange);
    }
  });
};

// Set up event listeners after the DOM has loaded
document.addEventListener("DOMContentLoaded", () => {

  const checkboxesToMonitor = ["bom-switch", "pwr-switch","control-switch","gsg-switch","dark-switch"]; // Add more IDs as needed


  setupCheckboxListeners(checkboxesToMonitor);
});

// Function to emit custom events for radio buttons

/**
 * Emits a custom event when the value of a radio button group changes.
 * @param {string} name - The name attribute of the radio button group.
 * @param {string} value - The selected value of the radio button.
 */
function emitRadioChange(name, value) {
  const eventName = `${name}-change`; // Creates a custom event name based on the radio button group name
  const eventDetail = value; // Details which radio button value was selected
  const event = new CustomEvent(eventName, { detail: eventDetail });
  document.dispatchEvent(event);
  console.log(`Event ${eventName} emitted with value: ${value}`);
};

// General function to handle radio button change events

/**
 * Handles the change event for a radio button.
 * @param {Event} event - The click event object.
 */
function handleRadioChange(event) {
  const radio = event.target;
  const isChecked = radio.checked;
  if (isChecked) {
    emitRadioChange(radio.name, radio.value);
  }
};

// Function to setup listeners for a list of radio button groups

/**
 * Sets up event listeners for a list of radio button groups.
 * @param {string[]} radioGroups - An array of radio button group names.
 */
function setupRadioListeners(radioGroups) {
  radioGroups.forEach((name) => {
    const radios = document.querySelectorAll(`input[name='${name}']`);
    radios.forEach((radio) => {
      radio.addEventListener("click", handleRadioChange);
    });
  });
};

// Set up event listeners after the DOM has loaded
document.addEventListener("DOMContentLoaded", () => {
  const radioGroupsToMonitor = ["mode"]; // Add more radio group names as needed
  setupRadioListeners(radioGroupsToMonitor);
});
